import { IRootScopeService, IScope, IQService } from "angular";
import { StateService } from "@uirouter/angularjs";
import { UserService } from "../userService";
import names from "wwwroot/json/names.json";
import { UIErrorHandlingService } from "@gtmhub/error-handling";

interface IUsersInviteBulkdScope extends IScope {
  users;
  indicators;
  isValid: boolean;
  usersJson;
  validateJson();
  populateUsers();
  invite();
}

export class UsersInviteBulkCtrl {
  public static $inject = ["$rootScope", "$scope", "$state", "UserService", "$q", "UIErrorHandlingService"];

  constructor(
    private $rootScope: IRootScopeService,
    private $scope: IUsersInviteBulkdScope,
    private $state: StateService,
    private userService: UserService,
    private $q: IQService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.invite = this.invite;
    this.$scope.users = [];
    this.$scope.indicators = {};
    this.$scope.validateJson = this.validateJson;
    this.$scope.populateUsers = this.populateUsers;
  }

  private validateJson = () => {
    this.$scope.isValid = true;
    try {
      JSON.parse(this.$scope.usersJson);
    } catch (e) {
      this.$scope.isValid = false;
    }
  };

  private populateUsers = () => {
    const users = angular.copy(names);
    for (let i = 0; i < users.length; i++) {
      const rand = Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "")
        .substr(0, 5);
      users[i]["email"] = users[i].lastName.toLowerCase() + "." + rand + "@okrs.tech";
    }

    this.$scope.users = users;
  };

  private invite = () => {
    if (this.$scope.users.length > 0) {
      this.inviteList(this.$scope.users);
    } else {
      this.inviteList(JSON.parse(this.$scope.usersJson));
    }
  };

  private inviteList = (users) => {
    const userInvitePromises = {};

    for (let i = 0; i < users.length; i++) {
      const userInvitePromise = this.userService.createUser(users[i], true);
      userInvitePromises["promise" + [i]] = userInvitePromise;
    }

    this.$scope.indicators.sending = true;
    this.$q.all(userInvitePromises).then(
      () => {
        this.$rootScope.$broadcast("usersChanged", true);
        this.$scope.indicators.sending = false;
        this.$state.go("^.^");
      },
      (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "sending", inline: true })
    );
  };
}
